import { VorgangItemResponse } from '@/types/service-response'

export class ProjectBookingStart {
  public constructor (
    readonly SchrittID: number,
    readonly Bezeichnung: string | null,
    readonly Selektiert: boolean,
    readonly Parent: number | null,
    readonly Children: ProjectBookingStart[]
  ) {}

  static createFromResponse (responseData: VorgangItemResponse[]): Array<ProjectBookingStart> {
    let result: Array<ProjectBookingStart> = []
    if (responseData) {
      result = responseData.map((item: VorgangItemResponse) => {
        return new ProjectBookingStart(
          item.SchrittID,
          item.Bezeichnung,
          item.Selektiert,
          item.Parent,
          item.Children ? ProjectBookingStart.createFromResponse(item.Children) : []
        )
      })
    }
    return result
  }
}
